export default {"src":"/_next/static/media/facebook-icon-white.5d6386c9.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};